var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductionLineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0095 1.92007L16.9095 4.54007C18.6095 5.29007 18.6095 6.53007 16.9095 7.28007L11.0095 9.90007C10.3395 10.2001 9.23953 10.2001 8.56953 9.90007L2.66953 7.28007C0.969531 6.53007 0.969531 5.29007 2.66953 4.54007L8.56953 1.92007C9.23953 1.62007 10.3395 1.62007 11.0095 1.92007Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10C1 10.84 1.63 11.81 2.4 12.15L9.19 15.17C9.71 15.4 10.3 15.4 10.81 15.17L17.6 12.15C18.37 11.81 19 10.84 19 10",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15C1 15.93 1.55 16.77 2.4 17.15L9.19 20.17C9.71 20.4 10.3 20.4 10.81 20.17L17.6 17.15C18.45 16.77 19 15.93 19 15",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductionLineIcon);
export default __webpack_public_path__ + "static/media/production-line-icon.91264817047d728253e5be0020867111.svg";
export { ForwardRef as ReactComponent };